var cibCss3Shiled = ["32 32", "<path d='M4 2l2.181 24.738 9.819 3.262 9.819-3.262 2.181-24.738zM23.569 7l-0.3 2.956-7.225 3.087h6.969l-0.8 9.163-6.137 1.794-6.175-1.825-0.4-4.619h3.056l0.2 2.394 3.287 0.831 3.419-0.962 0.231-3.85-10.406-0.031-0.225-2.894 7.413-3.087h-7.681l-0.363-2.956z'/>"];

export { cibCss3Shiled };

